import script from "./ImageDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./ImageDisplay.vue?vue&type=style&index=0&id=2882f90a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2882f90a"]])

export default __exports__